<template>
  <div>
    <div class="add-box">
      <div ref="imgbox" v-if="uploadList && viewType" class="upload-list2-wrap">
        <div
          class="upload-list2"
          v-for="(item, index) in uploadList"
          :key="index"
        >
          <template v-if="item.status === 'finished'">
            <span
              class="pdf-box2"
              v-if="/(.pdf)$/i.test(item.response.data.url)"
              @click="clickFile(item.response.data.url)"
              >{{ item.oldFileName }}</span
            >
            <span v-else>
              <img
                :data-original="`${item.response.data.url}`"
                :src="item.response.data.url"
              />
            </span>
            <div class="upload-list2-cover" v-if="isEdit">
              <Icon type="md-remove" @click.native="handleRemove(index)"></Icon>
            </div>
          </template>
          <template v-else>
            <Progress
              v-if="item.showProgress"
              :percent="item.percentage"
              hide-info
            ></Progress>
          </template>
        </div>

        <Upload
          ref="upload"
          :show-upload-list2="false"
          multiple
          :default-file-list="defaultList"
          :before-upload="handleBeforeUpload"
          :format="['jpg', 'jpeg', 'png', 'pdf']"
          :on-format-error="handleFormatError"
          :on-success="handleSuccess"
          :action="actionUrl"
          :headers="uploadHeaders"
          style="display: inline-block; width: 180px; height: 180px"
        >
          <div class="file-upload-box2" v-if="isEdit">
            <Icon type="md-add" size="20"></Icon>
          </div>
        </Upload>
      </div>

      <div ref="imgbox" v-if="uploadList && !viewType">
        <div
          class="upload-list2"
          v-for="(item, index) in uploadList"
          :key="index"
        >
          <span
            class="pdf-box2"
            v-if="/(.pdf)$/i.test(item.response.data.url)"
            @click="clickFile(item.response.data.url)"
            >{{ item.oldFileName }}</span
          >
          <span v-else>
            <img
              :data-original="`${item.response.data.url}`"
              :src="item.response.data.url"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/utils/auth";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import {sleep} from "@/utils/util";
const union = (...arr) => [...new Set(arr.flat())];
const assign = (o) => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];

export default {
  name: "UploadImg",
  props: {
    viewType: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    maxLength:{
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      viewer: null,
      uploadList: [],
      uuidList: [],
      fileList: [],
      defaultList: [],
      fileVisible: false,
      file: null, // 上传
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
    };
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    setList(addUrlList) {
      this.defaultList = addUrlList;
      this.uploadList = [];
      this.uploadList = union(this.uploadList, this.defaultList);
      this.destroyViewer();
      this.$nextTick(() => {
        this.initImageTools();
      });
    },
    clickFile(url) {
      window.open(url);
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " +
          file.name +
          " 格式不正确，请上传 jpg 或 png 或 jpeg 格式的图片, .pdf 格式的文件。",
      });
    },
    handleBeforeUpload(file) {
      if (file.size > 3072000) {
        this.$XModal.alert({
          message: '单个附件大小不能超过3M，请压缩后上传',
          status: "error",
        });
        return false;
      }
      let maxFileNum = this.maxLength ? this.maxLength : 5
      if (this.$refs.upload.fileList.length > maxFileNum) {
        this.$XModal.alert({
          message: '最多只能上传' + maxFileNum + '张',
          status: "error",
        });
        return false;
      }
      this.uploadList = this.$refs.upload.fileList;
    },
    handleRemove(i) {
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          //   console.log(i);
          //   debugger
          this.$refs.upload.fileList.splice(i, 1);
          this.uploadList = this.$refs.upload.fileList;
          this.$emit("fileList", this.uploadList);
        }
      });
    },
    handleSuccess(res, file, fileList) {
      let isEmit = false;
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].response) {
          isEmit = true;
        } else {
          isEmit = false;
          break;
        }
      }

      if (isEmit) {
        this.$emit("fileList", this.uploadList);
        this.$nextTick(() => {
          this.initImageTools();
        });
      }
    },
    destroyViewer() {
      this.viewer ? this.viewer.destroy() : "";
    },
    initImageTools() {
      //初始化 viewerjs
      const ViewerDom = this.$refs.imgbox;
      this.viewer = new Viewer(ViewerDom, {
        url: "data-original",
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          reset: 1,
        },
        show: function () {
          this.viewer.update();
        },
      });
    },
  },
};
</script>

<style>
.upload-list2-wrap {
  display: flex;
  flex-wrap: wrap;
}

.upload-list2 {
  display: inline-block;
  width: 180px;
  height: 180px;
  text-align: center;
  line-height: 180px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-left: 4px;
  vertical-align: middle;
  margin-bottom: 10px;
}

.upload-list2 img {
  width: 100%;
  height: 100%;
  border-style: none;
}

.add-box .file-upload-box2 {
  height: 180px;
  width: 180px;
  line-height: 180px;
  border: 1px dashed #dcdee2;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
}

.upload-list2:hover .upload-list2-cover {
  display: block;
}

.upload-list2-cover {
  display: none;
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
}

.upload-list2-cover i {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin: 0 auto;
  text-indent: 0;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 20px;
}
.upload-list2 .pdf-box2 {
  height: 180px;
  width: 180px;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}

.upload-list2 .pdf-box2::before {
  content: "PDF";
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0px;
  top: 0px;
  height: 180px;
  width: 180px;
  color: white;
  text-align: center;
}

.upload-list2 .ivu-progress {
  width: 96%;
  margin: 0 auto;
}
</style>
